import React from 'react';
import '../assets/styles/DownloadConfirmationModal.css';

export const DownloadConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    const handleYes = () => {
        onConfirm(); // Trigger download and email
        onClose();
    };

    const handleNo = () => {
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleNo}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Question Icon */}
                <div className="question-icon-wrapper">
                    <div className="question-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                            <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                    </div>
                </div>

                {/* Confirmation Message */}
                <h2 className="modal-title">Download CV?</h2>
                <p className="modal-message">
                    Would you like to download Ushan's CV? I'll be notified about your interest! 📄
                </p>

                {/* Info Box */}
                <div className="modal-info">
                    <p className="info-text">
                        <span className="info-icon">📧</span>
                        Email notification will be sent
                    </p>
                </div>

                {/* Yes/No Buttons */}
                <div className="modal-buttons">
                    <button className="modal-btn modal-btn-no" onClick={handleNo}>
                        <span>No, Thanks</span>
                    </button>
                    <button className="modal-btn modal-btn-yes" onClick={handleYes}>
                        <span>Yes, Download</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
